import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

interface EmptyStateProps {
  title: ReactNode;
  hint?: ReactNode;
  icon?: LucideIcon;
  action?: ReactNode;
  /** card: own .card, py-8 · page: no box, py-16 · inset: no box, py-6 (inside an existing card) */
  variant?: 'card' | 'page' | 'inset';
  titleAs?: 'p' | 'h1' | 'h2';
  className?: string;
}

const WRAPPER: Record<NonNullable<EmptyStateProps['variant']>, string> = {
  card: 'card px-4 py-8 text-center',
  page: 'py-16 text-center',
  inset: 'py-6 text-center',
};

/** The original empty state: optional icon, muted title, hint and an action. */
export function EmptyState({ title, hint, icon: Icon, action, variant = 'card', titleAs: Title = 'p', className }: EmptyStateProps): JSX.Element {
  return (
    <div className={cn(WRAPPER[variant], className)}>
      {Icon && <Icon aria-hidden="true" className="mx-auto mb-3 h-8 w-8 text-muted-foreground" />}
      <Title className="text-sm font-medium text-muted-foreground">{title}</Title>
      {hint && <p className="mt-1 text-xs text-muted-foreground">{hint}</p>}
      {action && <div className="mt-3 flex justify-center">{action}</div>}
    </div>
  );
}
